let list = [];

for (let i = 0; i < 15; i++) {
    list.push({
        id: i + 1,
        name: '纺织001',
        data: '温度:55℃',
        date: '2019/09/11 12:21:20'
    })
}

export default list;



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/index/querySssjList.js